export default __webpack_public_path__ + "static/media/remos-signal.736d9c3b.png";